// extracted by mini-css-extract-plugin
export default {"root":"HsUDb5nhfaS4XvoSH8wd","site-notes":"yjA4Hse9Yzca7ans_Md5","notes-heading":"Jyo5f2vSmAWpG_c4K793"};